import React, { createContext } from "react"
import { useLocalObservable } from "mobx-react"
import createStore from "../Stores/PTKMStore/ptkmStore"

const PTKMStoreContext = createContext(createStore())

export const PTKMStoreContextProvider = ({ children }: any) => {
	const ptkmStore = useLocalObservable(createStore)

	return <PTKMStoreContext.Provider value={ptkmStore}>{children}</PTKMStoreContext.Provider>
}

export const usePTKMStore = () => React.useContext(PTKMStoreContext)
